import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

const PERIOD_KEYS = ["today", "7days", "30days", "thisMonth", "lastMonth"];

export function PeriodSelector({ selectedPeriod, onPeriodChange }) {
  const { t } = useTranslation();

  return (
    <div className="flex gap-2 flex-wrap" data-testid="period-selector">
      {PERIOD_KEYS.map(key => (
        <Button
          key={key}
          variant={selectedPeriod === key ? "default" : "outline"}
          size="sm"
          onClick={() => onPeriodChange(key)}
          data-testid={`period-${key}`}
        >
          {t(`reports.periods.${key}`)}
        </Button>
      ))}
    </div>
  );
}
